import React from 'react'; // TODO: check

const context = /*#__PURE__*/React.createContext(null);
context.displayName = 'NavbarContext';
export default context;